import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { navigationCancelingError } from '@app/guards/navigation-canceling-error';
import { Observable } from 'rxjs';
import { SecurityService } from '@app/services/security.service';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeAccessGuard implements CanActivate {

  constructor(private securityService: SecurityService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (next?.data?.roles) {
      return this.securityService.hasUserAnyAppRole(next.data.roles)
        .pipe(
          tap(hasUserAppRole => {
            if (!hasUserAppRole) {
              throw navigationCancelingError('unauthenticated');
            }
          }));
    } else {
      return true;
    }
  }
}
